<template>
  <div class="add-bottom">
    <div class="tracks">
      <a @click="playPrevious">&larr;</a>
      <a @click="playNext">&rarr;</a>
    </div>
    <div class="playlist-wrap">
      <ul class="list-unstyled">
        <li v-for="(file, index) in tracks" :key="file.id" class="audio" :class="{ selected: file == currentAudio }" @click="playTrack(file)">
          <div class="item">
            <span class="number">{{ index + 1 }}.</span>
            <span class="title">{{ file.title }} </span>
            <span class="duration">{{ file.duration }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PlaylistPlayer',
  props: {
    tracks: Array
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['event', 'playlist', 'currentAudio'])
  },
  watch: {
    event: function (val) {
      if (val === 'Ended') {
        this.playNext()
      }
    }
  },
  methods: {
    ...mapActions([
      'setCurrentAudio',
      'setEvent',
      'setPlaylist'
    ]),
    playTrack (track) {
      const self = this

      self.setPlaylist(self.tracks)
      self.setAttribute(track)
    },
    setAttribute (track) {
      if (this.currentAudio !== track) {
        // hack for always paly despite the same event
        this.setEvent(this.event === 'Playing'
          ? 'Play' : 'Playing')
        this.setCurrentAudio(track)
        return
      }

      this.setEvent(this.event === 'Playing'
        ? 'Paused' : 'Playing')
    },
    playNext () {
      const self = this
      const tracks = self.playlist

      if (typeof self.currentAudio.title === 'undefined') {
        self.setCurrentAudio(tracks[0])
        self.playTrack(self.currentAudio)
        return
      }

      const index = tracks.indexOf(self.currentAudio)

      if (index === self.playlist.length - 1) {
        self.playTrack(tracks[0])
        return
      }

      if (index === -1) {
        console.log('index -1', tracks.slice(0, 1))
        self.playTrack(tracks[0])
        return
      }

      const indexNextTrack = index + 1

      let nextTrack = tracks[indexNextTrack]

      if (typeof nextTrack === 'undefined') {
        console.log('undefined')
        nextTrack = tracks[0]
      }

      self.playTrack(nextTrack)
    },
    playPrevious () {
      const self = this
      const tracks = self.playlist

      if (typeof self.currentAudio.title === 'undefined') {
        self.setCurrentAudio(tracks[tracks.length - 1])
        self.playTrack(self.currentAudio)
        return
      }

      const index = self.tracks.indexOf(self.currentAudio)
      let previousTrack = tracks[index - 1]

      if (typeof previousTrack === 'undefined') {
        previousTrack = tracks[tracks.length - 1]
      }

      self.playTrack(previousTrack)
    }
  }
}
</script>

<style>
  .tracks {
    font-size:0;
    position:relative;
    text-align:center;
  }

  .audio {
    cursor:pointer;
    padding:21px;
  }

  .audio:hover {
    background-color:rgba(0,0,0,.1);
  }

  .audio .item {
    position:relative;
  }

  .audio .title {
    left:50px;
    overflow:hidden;
    position:absolute;
    right:65px;
    text-overflow:ellipsis;
    top:0;
    white-space:nowrap;
  }

  .audio .number {
    width:25px;
  }

  .duration {
    padding-left:21px;
    position:absolute;
    right:21px;
    top:0;
  }

  .audio.selected,
  .audio.selected:hover {
    background-color:rgba(0,0,0,.1);
    color:#fff;
    cursor:default !important;
  }

  .tracks a {
    border-radius:3px;
    color:#fff;
    cursor:pointer;
    display:inline-block;
    font-size:2rem;
    height:35px;
    line-height:.175;
    margin:0 5px 30px;
    padding:10px;
    text-decoration:none;
    transition:background .3s ease;
  }

  .tracks a:hover,
  .tracks a:active {
    background-color:rgba(0,0,0,.1);
    color:#fff;
  }

  .tracks a::-moz-focus-inner {
    border:0;
    padding:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Playlist.vue